/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetShowProductDocumentsQueryResponse, GetShowProductDocumentsPathParams, GetShowProductDocumentsQueryParams, GetShowProductDocuments404 } from "../../models/GetShowProductDocuments";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetShowProductDocumentsUrl({ productCode }: { productCode: GetShowProductDocumentsPathParams["productCode"] }) {
  const res = { method: 'GET', url: `/api/v1/products/${productCode}/documents` as const }  
  return res
}

/**
 * {@link /api/v1/products/:productCode/documents}
 */
export async function getShowProductDocuments({ productCode, params }: { productCode: GetShowProductDocumentsPathParams["productCode"]; params: GetShowProductDocumentsQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetShowProductDocumentsQueryResponse, ResponseErrorConfig<GetShowProductDocuments404>, unknown>({ method : "GET", url : getGetShowProductDocumentsUrl({ productCode }).url.toString(), params, ... requestConfig })  
  return res.data
}